<template>
  <ul class="items" v-if="display_style == 1">
    <li
      :id="'chapter-' + chapter.id"
      class="chapter-item"
      v-for="chapter in chapters"
      :key="chapter.id"
      :class="{ 'chapter-expand': chapterExpand[chapter.id] }"
    >
      <div
        class="chapter-title"
        :class="{ 'chapter-title-expand': chapterExpand[chapter.id] }"
        @click="toggleExpand(chapter.id)"
        :title="chapter.title"
      >
        {{ chapter.title }}
      </div>
      <template v-if="chapter.child">
        <div
          class="chapter-content"
          v-for="period in chapter.child"
          :key="period.id"
          :class="{ current: currentPeriod == period.id }"
        >
          <CoursePeriod
            :period="period"
            :course="course"
            :tryText="tryText"
          ></CoursePeriod>
        </div>
      </template>
    </li>
  </ul>
  <div class="chapter-periods" v-else>
    <div
      class="chapter-content chapter-content-alone"
      :class="{ current: currentPeriod == period.id }"
      v-for="period in chapters"
      :key="period.id"
      style="display: block"
    >
      <CoursePeriod
        :period="period"
        :course="course"
        :tryText="tryText"
      ></CoursePeriod>
    </div>
  </div>
</template>
<script>
import CoursePeriod from "./CoursePeriod.vue";

export default {
  name: "CourseChapter",
  components: {
    CoursePeriod,
  },
  data() {
    return {
      id: "",
      type: 0,
      chapters: [],
      chapterExpand: {},
      display_style: 0,
    };
  },
  props: {
    course: {
      type: Object,
    },
    currentPeriod: {
      type: String,
    },
    tryText: {
      type: String,
      default: "试看",
    },
  },
  async created() {
    await this.getData();
  },
  watch: {
    course: async function () {
      await this.getData();
    },
  },
  methods: {
    async getData() {
      this.id = this.course.id;
      this.type = this.course.course_type;
      await this.getChapter();
      if (this.currentPeriod) {
        this.chapters.forEach(c => {
          if (!c.child) {
            return;
          }
          c.child.forEach(p => {
            if (p.id == this.currentPeriod) {
              this.chapterExpand[c.id] = 1;
            }
          });
        });
      }
    },
    formatPeriod(period) {
      let teacherNames = [];
      if (period.teachers) {
        period.teachers.forEach(t => {
          teacherNames.push(t.teacher_name);
        });
      }
      period.teacher_name = teacherNames.join(",");
      let files = [];
      if (period.datum && period.datum.length > 0) {
        let datum_id = period.datum[0].datum_id;
        let fileNames = period.datum[0].file_name.split(";");
        for (let i = 0; i < fileNames.length; i++) {
          let fileName = fileNames[i];
          files.push({
            file_name: fileName,
            datum_id: datum_id,
          });
        }
      }
      period.files = files;
    },
    async getChapter() {
      if (!this.id) {
        return;
      }
      if (this.type == 9 || this.course.type == 4) {
        return;
      }
      let chapters = await this.$http.post("/api/app/courseChapter", {
        id: this.id,
      });
      if (chapters.length > 0) {
        if (!chapters[0].periods_title) {
          this.display_style = 1;
          chapters.forEach(c => {
            this.$set(this.chapterExpand, c.id, 0);
            if (!c.child) {
              return;
            }
            c.child.forEach(child => {
              this.formatPeriod(child);
            });
          });
        } else {
          chapters = chapters.filter(c => c.parent_id != 0);
          chapters.forEach(c => {
            this.formatPeriod(c);
          });
        }
      }
      this.chapters = chapters;
    },
    toggleExpand(id) {
      for (let key in this.chapterExpand) {
        if (key == id) {
          continue;
        }
        this.chapterExpand[key] = 0;
      }
      if (this.chapterExpand[id] == 0) {
        this.chapterExpand[id] = 1;
      } else {
        this.chapterExpand[id] = 0;
      }
      this.$emit("chapterClick", id);
    },
    getNextPeriod(id) {
      let chapters = this.chapters;
      if (!chapters[0].periods_title) {
        chapters = chapters.filter(c => c.child && c.child.length > 0);
        let c, p;
        let chapter;
        for (c = 0; c < chapters.length; c++) {
          chapter = chapters[c];
          if (!chapter.child) {
            return;
          }
          for (p = 0; p < chapter.child.length; p++) {
            let period = chapter.child[p];
            if (period.id == id) {
              break;
            }
          }
          if (p == chapter.child.length) {
            continue;
          }
          let nextPeriod = chapter.child[p + 1];
          if (nextPeriod) {
            return nextPeriod;
          }
          let nextChapter = chapters[c + 1];
          if (!nextChapter) {
            return;
          }
          return nextChapter.child[0];
        }
      } else {
        let i;
        for (i = 0; i < chapters.length; i++) {
          let chapter = chapters[i];
          if (chapter.id == id) {
            break;
          }
        }
        return chapters[i + 1];
      }
    },
  },
};
</script>
<style lang="scss" scoped>
@import "@/assets/css/varibles.scss";

.items {
  overflow: hidden;
}

.chapter-title {
  height: 58px;
  background: rgba(255, 255, 255, 1);
  box-shadow: 0px 4px 16px 0px rgba(0, 0, 0, 0.06);
  border-radius: 10px;
  font-size: 20px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: rgba(0, 0, 0, 0.85);
  line-height: 58px;
  padding: 0 34px 0 20px;
  cursor: pointer;
  position: relative;
  margin-bottom: 27px;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;

  &::after {
    position: absolute;
    content: "";
    width: 20px;
    height: 12px;
    top: 23px;
    right: 20px;
    background-size: 100% 100%;
    background-image: url("~@/assets/images/video/down@3x.png");
  }

  &.chapter-title-expand::after {
    background-image: url("~@/assets/images/video/up@3x.png");
  }
}

.chapter-content {
  display: none;
  margin-bottom: 30px;

  &.chapter-content-alone {
    padding-left: 0;
    margin-bottom: 24px;

    &:first-child {
      padding-top: 24px;
    }

    &:last-child {
      padding-bottom: 24px;
    }

    /deep/ {
      .period-point {
        margin-right: 10px;
      }

      .period-file {
        padding-left: 14px;
      }
    }
  }

  &:last-child {
    margin-bottom: 0;
  }
}

.chapter-expand .chapter-content {
  display: block;
}

.chapter-item {
  margin: 0 25px 40px 25px;

  &:first-child {
    margin-top: 25px;
  }
}

.chapter-periods {
  .chapter-content {
    margin-left: 25px;
    margin-right: 25px;
  }
}
</style>
